module.exports = __webpack_public_path__ + "img/url-locator.c3b69524.png";